import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Modal,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
  FiFileText,
  FiDownload,
  FiFile,
} from "react-icons/fi";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
const API_HOST = process.env.REACT_APP_API_URL;
const cookies = new Cookies();

const Clientes = () => {
  const id_Usuario = cookies.get("usuario");

  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [tiposClientes, setTiposClientes] = useState([]);
  const itemsPerPageOptions = [5, 10, 20, 50];

  const [formData, setFormData] = useState({
    nombre: "",
    identidad: "",
    telefono: "",
    email: "",
    idTipoCliente: "",
    direccion: "",
    fechaNacimiento: "",
    idUsuario: id_Usuario,
  });

  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchData(currentPage + 1, itemsPerPage, searchTerm);
    fetchTiposClientes();
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    fetchData(1, itemsPerPage, searchTerm);
    setCurrentPage(0);
  }, [searchTerm]);

  const fetchData = async (page, pageSize, search) => {
    const bearertoken = cookies.get("token");

    try {
      const response = await fetch(
        `${API_HOST}/clientes?page=${page}&pageSize=${pageSize}&search=${search}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
        }
      );
      const result = await response.json();
      setData(result.data);
      setTotalItems(result.totalItems);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Error", "Error al cargar los clientes", "error");
    }
  };

  const fetchTiposClientes = async () => {
    const bearertoken = cookies.get("token");

    try {
      const response = await fetch(`${API_HOST}/tipoClientes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
      });
      const result = await response.json();
      setTiposClientes(result);
    } catch (error) {
      console.error("Error fetching tipos clientes:", error);
      Swal.fire("Error", "Error al cargar los tipos de cliente", "error");
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (
      !formData.nombre ||
      formData.nombre.length < 3 ||
      formData.nombre.length > 100
    ) {
      newErrors.nombre = "El nombre debe tener entre 3 y 100 caracteres";
    }

    const identidadRegex = /^\d{4}-\d{4}-\d{5}$/;
    if (!formData.identidad || !identidadRegex.test(formData.identidad)) {
      newErrors.identidad = "La identidad debe tener formato ####-####-#####";
    }

    if (!formData.telefono || !/^\d{4}-\d{4}$/.test(formData.telefono)) {
      newErrors.telefono = "El teléfono es obligatorio (formato ####-####)";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      !formData.email ||
      !emailRegex.test(formData.email) ||
      formData.email.length < 5 ||
      formData.email.length > 255
    ) {
      newErrors.email = "Ingrese un email válido (5-255 caracteres)";
    }

    if (!formData.fechaNacimiento) {
      newErrors.fechaNacimiento = "La fecha de nacimiento es requerida";
    }

    if (!formData.idTipoCliente) {
      newErrors.idTipoCliente = "El tipo de cliente es requerido";
    }

    if (
      formData.direccion &&
      (formData.direccion.length < 5 || formData.direccion.length > 255)
    ) {
      newErrors.direccion = "La dirección debe tener entre 5 y 255 caracteres";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleShowModal = (item = null) => {
    fetchTiposClientes();
    if (item) {
      const formattedItem = {
        ...item,
        fechaNacimiento: item.fechaNacimiento.split("T")[0],
      };
      const { idCliente, casillero, createdAt, updatedAt, ...filteredItem } =
        formattedItem;
      setFormData(filteredItem);
      setEditingId(item.idCliente);
    } else {
      setFormData({
        nombre: "",
        identidad: "",
        telefono: "",
        email: "",
        idTipoCliente: "",
        direccion: "",
        fechaNacimiento: "",
        idUsuario: id_Usuario,
      });
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor corrija los errores en el formulario",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `/clientes/${editingId}` : "/clientes";
    const dataToSubmit = { ...formData };
    const bearertoken = cookies.get("token");

    try {
      const response = await fetch(`${API_HOST + url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }

      Swal.fire(
        "Éxito",
        editingId ? "Actualizado correctamente" : "Creado correctamente",
        "success"
      );
      fetchData(currentPage + 1, itemsPerPage, searchTerm);
      handleCloseModal();
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "Hubo un problema en la operación",
        "error"
      );
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");

    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/clientes/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: "457896",
            },
          });
          Swal.fire("Eliminado!", "El registro ha sido eliminado.", "success");
          fetchData(currentPage + 1, itemsPerPage, searchTerm);
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar el registro", "error");
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(totalItems / itemsPerPage);
  const displayedData = data;

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("en-CA", options);
  };

  const exportData = async (format) => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(
        `${API_HOST}/clientes?export=true&search=${searchTerm}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
            "Content-Type": "application/json", 
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al exportar los datos");
      }
      const result = await response.json();
      if (format === "excel") {
        exportToExcelFile(result);
      } else if (format === "pdf") {
        exportToPDFFile(result);
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "No se pudieron exportar los datos",
        "error"
      );
    }
  };

  const exportToExcelFile = (exportData) => {
    const excelData = exportData.map((item) => ({
      ID: item.idCliente,
      Nombre: item.nombre,
      Identidad: item.identidad,
      Teléfono: item.telefono,
      Email: item.email,
      "Tipo Cliente": item.tipoClienteInfo?.nombreTipoCliente || "N/A",
      Dirección: item.direccion || "N/A",
      "Fecha Nacimiento": new Date(item.fechaNacimiento).toLocaleDateString(
        "en-CA"
      ),
      "Fecha Registro": new Date(item.createdAt).toLocaleDateString("en-CA"),
      "Última Actualización": new Date(item.updatedAt).toLocaleDateString(
        "en-CA"
      ),
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");

    const colWidths = [
      { wch: 5 },
      { wch: 25 },
      { wch: 15 },
      { wch: 12 },
      { wch: 25 },
      { wch: 15 },
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
    ];
    worksheet["!cols"] = colWidths;

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2c3e50" } },
      alignment: { horizontal: "center" },
      border: {
        top: { style: "thin", color: { rgb: "1a1a1a" } },
        bottom: { style: "thin", color: { rgb: "1a1a1a" } },
        left: { style: "thin", color: { rgb: "1a1a1a" } },
        right: { style: "thin", color: { rgb: "1a1a1a" } },
      },
    };

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });
      if (!worksheet[headerCell].s) worksheet[headerCell].s = {};
      Object.assign(worksheet[headerCell].s, headerStyle);

      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        const cell = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cell]) continue;
        if (!worksheet[cell].s) worksheet[cell].s = {};
        worksheet[cell].s.border = {
          top: { style: "thin", color: { rgb: "e0e0e0" } },
          bottom: { style: "thin", color: { rgb: "e0e0e0" } },
          left: { style: "thin", color: { rgb: "e0e0e0" } },
          right: { style: "thin", color: { rgb: "e0e0e0" } },
        };
        if ([0, 2, 3, 5, 7, 8, 9].includes(C)) {
          worksheet[cell].s.alignment = { horizontal: "center" };
        }
      }
    }

    const title = "Listado de Clientes";
    const company = "MBOX ";
    const date = new Date().toLocaleDateString("en-CA", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const infoSheet = XLSX.utils.aoa_to_sheet([
      [title],
      [""],
      [`Empresa: ${company}`],
      [`Fecha de exportación: ${date}`],
      [`Total clientes: ${exportData.length}`],
      [""],
    ]);

    infoSheet["A1"].s = { font: { bold: true, size: 16 } };
    infoSheet["A3"].s = { font: { italic: true } };
    infoSheet["A4"].s = { font: { italic: true } };
    infoSheet["A5"].s = { font: { bold: true } };

    XLSX.utils.book_append_sheet(workbook, infoSheet, "Informe");

    XLSX.writeFile(
      workbook,
      `Clientes_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  const exportToPDFFile = (exportData) => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Listado de Clientes", 14, 15);

    doc.setFontSize(10);
    doc.text(`Exportado: ${new Date().toLocaleString()}`, 14, 22);

    autoTable(doc, {
      head: [
        ["ID", "Nombre", "Identidad", "Teléfono", "Email", "Tipo Cliente"],
      ],
      body: exportData.map((item) => [
        item.idCliente,
        item.nombre,
        item.identidad,
        item.telefono,
        item.email,
        item.tipoClienteInfo?.nombreTipoCliente || "N/A",
      ]),
      startY: 25,
      styles: {
        fontSize: 8,
        cellPadding: 1,
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
    });

    doc.save("clientes.pdf");
  };

  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Clientes</h5>
            <div>
              <Dropdown className='d-inline me-2'>
                <Dropdown.Toggle variant='outline-primary' size='sm'>
                  <FiDownload className='me-1' /> Exportar
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => exportData("excel")}>
                    <FiFileText className='me-2' /> Excel (.xlsx)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportData("pdf")}>
                    <FiFile className='me-2' /> PDF (.pdf)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button
                variant='success'
                onClick={() => handleShowModal()}
                size='sm'
              >
                Agregar Nuevo
              </Button>
            </div>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por nombre, identidad, teléfono o correo...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                style={{ width: "80px" }}
                className='border'
                size='sm'
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>ID</th>
                  <th className='border-top-0'>Nombre</th>
                  <th className='border-top-0'>Identidad</th>
                  <th className='border-top-0'>N° Casillero</th>
                  <th className='border-top-0'>Teléfono</th>
                  <th className='border-top-0'>Email</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.idCliente}>
                    <td className='text-muted'>{item.idCliente}</td>
                    <td>{item.nombre}</td>
                    <td>{item.identidad}</td>
                    <td>{item.casillero}</td>
                    <td>{item.telefono}</td>
                    <td>{item.email}</td>
                    <td className='text-end'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(item)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-danger'
                        onClick={() => handleDelete(item.idCliente)}
                        className='me-2 action-btn'
                        title='Eliminar'
                        size='sm'
                      >
                        <FiTrash />
                      </Button>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleView(item)}
                        title='Ver detalles'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {displayedData.length} de {totalItems} registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
            />
          </div>
        </div>
      </div>

      {/* Modal para agregar/editar */}
      <Modal show={showModal} onHide={handleCloseModal} centered size='lg'>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>{editingId ? "Editar" : "Agregar"} Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Nombre
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='nombre'
                    value={formData.nombre}
                    onChange={handleChange}
                    isInvalid={!!errors.nombre}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.nombre}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Identidad
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='identidad'
                    value={formData.identidad}
                    onChange={handleChange}
                    placeholder='####-####-#####'
                    isInvalid={!!errors.identidad}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.identidad}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Teléfono
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='telefono'
                    value={formData.telefono}
                    onChange={handleChange}
                    placeholder='####-####'
                    isInvalid={!!errors.telefono}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.telefono}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Email
                  </Form.Label>
                  <Form.Control
                    type='email'
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Fecha de Nacimiento
                  </Form.Label>
                  <Form.Control
                    type='date'
                    name='fechaNacimiento'
                    value={formData.fechaNacimiento}
                    onChange={handleChange}
                    isInvalid={!!errors.fechaNacimiento}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.fechaNacimiento}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Tipo Cliente
                  </Form.Label>
                  <Form.Control
                    as='select'
                    name='idTipoCliente'
                    value={formData.idTipoCliente}
                    onChange={handleChange}
                    isInvalid={!!errors.idTipoCliente}
                    className='border'
                  >
                    <option value=''>Seleccionar</option>
                    {tiposClientes.map((tipo) => (
                      <option
                        key={tipo.idTipoCliente}
                        value={tipo.idTipoCliente}
                      >
                        {tipo.nombreTipoCliente}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type='invalid'>
                    {errors.idTipoCliente}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Dirección</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={3}
                    name='direccion'
                    value={formData.direccion}
                    onChange={handleChange}
                    isInvalid={!!errors.direccion}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.direccion}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles del Cliente
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Información Básica</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>ID:</span>{" "}
                    {selectedItem.idCliente}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Nombre:</span>{" "}
                    {selectedItem.nombre}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Identidad:</span>{" "}
                    {selectedItem.identidad}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Teléfono:</span>{" "}
                    {selectedItem.telefono}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Email:</span>{" "}
                    {selectedItem.email}
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Información Adicional</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Tipo Cliente:</span>{" "}
                    {selectedItem.tipoClienteInfo?.nombreTipoCliente}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Fecha Nacimiento:</span>{" "}
                    {(selectedItem.fechaNacimiento).slice(0.10)}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Dirección:</span>{" "}
                    {selectedItem.direccion || "N/A"}
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Registro</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Creado:</span>{" "}
                    {formatDate(selectedItem.createdAt)}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Actualizado:</span>{" "}
                    {formatDate(selectedItem.updatedAt)}
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Clientes;
